export const LIDO_STAKE_APR_URL = "https://eth-api.lido.fi/v1/protocol/steth/apr/sma";
